
import React from "react";
import { Link } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import { useAppContext } from "../context/AppContext";
import classNames from "classnames";

const ProductCard = ({ product }) => {
  const { toggleWishlist, wishlist, openQuickView, addToEnquiry } =
    useAppContext();

  const isInWishlist = wishlist.includes(product.id);

  const handleQuickViewClick = (e) => {
    e.preventDefault();
    openQuickView(product.id);
  };

  const handleImageKeyDown = (e) => {
    if (e.key === "Enter") {
      openQuickView(product.id);
    }
  };

  const handleEnquiryClick = (e) => {
    e.preventDefault();
    addToEnquiry(product);
  };

  return (
    <article className="product-card">
      <div className="product-img relative">
        <button
          className={classNames("wishlist-btn", { active: isInWishlist })}
          onClick={(e) => {
            e.preventDefault();
            toggleWishlist(product.id);
          }}
          aria-label={isInWishlist ? "Remove from wishlist" : "Add to wishlist"}
        >
          <FaHeart />
        </button>

        <Link
          to={`/product/${product.id}`}
          aria-label={`View details for ${product.name}`}
        >
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="cursor-pointer"
          />
        </Link>

        {product.isNew && <span className="product-badge">New</span>}
        {product.isFeatured && <span className="product-badge">Featured</span>}
      </div>

      <div className="product-info mt-2">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <div className="product-price text-primary font-bold my-1">
          ${product.price.toFixed(2)}
        </div>
        <div className="product-actions flex gap-2 mt-2">
          <Link
            to={`/product/${product.id}`}
            className="btn btn-outline"
            aria-label={`View details for ${product.name}`}
          >
            Details
          </Link>
          <button
            className="btn btn-sm"
            onClick={handleEnquiryClick}
            aria-label={`Enquire about ${product.name}`}
          >
            Enquiry
          </button>
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
